/* eslint-disable rover/no-platform-specific-globals-or-imports, no-underscore-dangle */
import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import ErrorBoundary from '@rover/react-lib/src/components/errorHandling/ErrorBoundary';
import DeviceContext from '@rover/react-lib/src/context/DeviceContext';
import HistoryContext from '@rover/react-lib/src/context/HistoryContext';
import QueryContext from '@rover/react-lib/src/context/QueryContext';
import { StrictModeContextProvider } from '@rover/react-lib/src/context/StrictModeContext';
import { SearchModalPerfHackStyles } from '@rover/react-lib/src/pages/search/SearchPage/components/Modals/PaginatedWizardModal/StyledDialogModal';
import I18nProvider from '@rover/rsdk/src/modules/I18n/I18nProvider';
import { GlobalStyles } from '@rover/shared/js/styles/globalStyles';
import getUserAgentFlags from '@rover/shared/js/utils/getUserAgentFlags';
import { getQueryParams } from '@rover/utilities/url';

import routes from '../routes';

import App from './App';

const queryClient = new QueryClient();
const locale = window.__LOCALE__;

const ClientEntry = (): JSX.Element => {
  return (
    <StrictModeContextProvider>
      <ErrorBoundary topLevel>
        <QueryContext.Provider value={getQueryParams()}>
          <HistoryContext.Provider value={window.history}>
            <DeviceContext.Provider value={getUserAgentFlags()}>
              <GlobalStyles />
              <SearchModalPerfHackStyles />
              <QueryClientProvider client={queryClient}>
                <I18nProvider locale={locale}>
                  <App routes={routes} />
                </I18nProvider>
              </QueryClientProvider>
            </DeviceContext.Provider>
          </HistoryContext.Provider>
        </QueryContext.Provider>
      </ErrorBoundary>
    </StrictModeContextProvider>
  );
};

export default ClientEntry;
